
<script>
import { watch, ref } from 'vue';
//import  jsPDF  from "jspdf";
import pdfMake from "pdfmake/build/pdfmake";
import { pdfFileName, openPdf } from '@/utils/pdfFile';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import SalesmanShopServices from '@/services/SalesmanShopServices';
import moment from 'moment';
//import htmlToPdfmake from 'html-to-pdfmake';
export default {
    props:{
        salesman_id: String,
        salesman_name: String,
        counter_all: Number
    },
    setup(props){
        const totalBalance=ref(0);
        const pdfData=ref([]);
        const documentDefinition=ref({});
        const body=ref([]);
        const loadPdf=async ()=>{
            await SalesmanShopServices.getAllPdfContent(props.salesman_id)
      			.then(response=>{	
                    pdfData.value=response.data.data;
      			})
                .then(() => {
                    totalBalance.value=0;
                    const formatMoney=(value)=>{
                        const num=parseFloat(value);
                        if(isNaN(num)) return '';
                        return num.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    };
                    const headerCell=(text, align)=>({text, style: 'tableHeader', alignment: align || 'center', fillColor: '#f3f3f3'});
                    const columns=[
                        headerCell('No', 'center'),
                        headerCell('Name', 'left'),
                        headerCell('Address', 'left'),
                        headerCell('Day', 'center'),
                        headerCell('Balance', 'right')
                    ];
                    body.value.push(columns);
                    let i=1;
                    pdfData.value.forEach(function(row) {
                        const dataRow=[];

                        dataRow.push({text: i.toString(), style: 'defaultFont', alignment: 'center'});

                        dataRow.push({
                            text: row['shop_name'] ? row['shop_name'].toString() : '',
                            style: 'defaultFont',
                            alignment: 'left'
                        });

                        dataRow.push({
                            text: row['address'] ? row['address'].toString() : '',
                            style: 'defaultFont',
                            alignment: 'left'
                        });

                        dataRow.push({
                            text: row['day'] ? row['day'].toString() : '',
                            style: 'defaultFont',
                            alignment: 'center'
                        });

                        dataRow.push({
                            text: formatMoney(row['currentBalance']),
                            style: 'defaultFont',
                            alignment: 'right'
                        });

                        if(row['currentBalance']!=""){
                            totalBalance.value=eval(totalBalance.value)+eval(row['currentBalance'])
                        }

                        i++;
                        body.value.push(dataRow);
                    });

                    body.value.push([
                        {text: 'Total', colSpan: 4, style: ['tableHeader'], alignment: 'right'},
                        {}, {}, {},
                        {text: formatMoney(totalBalance.value), style: ['tableHeader'], alignment: 'right'}
                    ]);
                })
                .then(() => {
                    documentDefinition.value = {
                        pageMargins: [30, 36, 30, 60],
                        content: [

                            {
                                columns: [
                                    {
                                    width: '100%',
                                    text: 'SALESMAN: '+props.salesman_name+" ("+props.salesman_id+")",
                                    style: [ 'defaultFont', 'mb2' ]

                                    }
                                ],
                                margin: [0, 0, 0, 6],
                            },
                            {
                                table: {
                                    headerRows: 1,
                                    widths: [30, '*', '*', 80, 110],
                                    body: body.value
                                },
                                layout: {
                                    hLineWidth: () => 0.7,
                                    vLineWidth: () => 0.7,
                                    hLineColor: () => '#000000',
                                    vLineColor: () => '#000000',
                                    paddingTop: () => 9,
                                    paddingBottom: () => 9,
                                    paddingLeft: () => 8,
                                    paddingRight: () => 8,
                                    fillColor: function (rowIndex, node) {
                                        if (rowIndex === 0) return '#f3f3f3';
                                        if (rowIndex === node.table.body.length - 1) return '#eaeaea';
                                        return rowIndex % 2 === 0 ? '#f7f7f7' : null;
                                    },
                                },
                            },
                        ],
                        styles: {
                            defaultFont: {
                            fontSize: 15,
                            bold: true
                            },
                            tableHeader: {
                            fontSize: 15,
                            bold: true,
                            alignment: 'center'
                            },
                            textRight: {
                            alignment: 'right'
                            },
                            textCenter: {
                            alignment: 'center'
                            },
                            mb2: {
                            margin:[0,0,0,2]
                            },

                        }
                        };
                })
                .then(() => {
                    pdfMake.vfs = pdfFonts;
                    openPdf(pdfMake, documentDefinition.value, pdfFileName(['Salesman-Shops', props.salesman_name], ''));
                    body.value=[];
                });

                
        }
        watch( ()=>props.counter_all, (currentValue, oldValue) => {
			if(currentValue!=oldValue && currentValue!=""){
                loadPdf();
			}
        });
        
        return {
            pdfData,
            totalBalance,
            documentDefinition,
            body
        }
    }
}
</script>
